// if(!getCookie('pltfm')) setCookie('pltfm','4')
import config from "config";
import moment from "moment";

const auth_url = config["auth_url"];
const cookiesDomain = config["cookiesDomain"];

Number.prototype.round = function (p) {
  p = p || 10;
  return parseFloat(this.toFixed(p));
};

var showError = function (message) {
  if (message) {
    $("#modal-error .modal-body p").html(message);
  } else {
    $("#modal-error .modal-body p").text(
      "Something went wrong at the other end. Please try again later or contact us"
    );
  }

  $("#modal-error").modal("show");
};

var showSuccess = function (message) {
  if (message) {
    $("#modal-success .modal-body p").html(message);
  } else {
    $("#modal-success .modal-body p").text("Congrats");
  }

  $("#modal-success").modal("show");
};

// Base64 url encode and decode
var Base64 = {
  _keyStr:
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=-&_,#[]{}()?$'\" ",
  encode: function (e) {
    return btoa(e);
  },
  decode: function (e) {
    return atob(e);
  },
  _utf8_encode: function (e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode((r >> 6) | 192);
        t += String.fromCharCode((r & 63) | 128);
      } else {
        t += String.fromCharCode((r >> 12) | 224);
        t += String.fromCharCode(((r >> 6) & 63) | 128);
        t += String.fromCharCode((r & 63) | 128);
      }
    }
    return t;
  },
  _utf8_decode: function (e) {
    var t = "";
    var n = 0;
    var r = (c1 = c2 = 0);
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode(((r & 31) << 6) | (c2 & 63));
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode(
          ((r & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
        );
        n += 3;
      }
    }
    return t;
  },
};

var getFromCache = function (method, params) {
  if (!CACHE[method] || !Object.keys(CACHE[method]).length) return null;

  if (new Date() - new Date(CACHE[method].timestamp) >= 3 * 60000) {
    CACHE[method] = {};
    return null;
  }
  var stored_params = Object.keys(CACHE[method]);
  params = JSON.stringify(params);
  for (var i = 0; i < stored_params.length; ++i) {
    if (params === stored_params[i]) {
      return CACHE[method][params];
    }
  }
  return null;
};

var setIntoCache = function (method, params, response) {
  if (!CACHE[method] || !Object.keys(CACHE[method]).length) {
    CACHE[method] = {
      timestamp: new Date().toString(),
    };
  }
  CACHE[method][JSON.stringify(params)] = response;
};

function getQueryStringParameters() {
  var query_string = location.href.split("?");
  if (query_string.length !== 2) {
    return {};
  }
  var json = {};
  query_string[1].split("&").map(function (element) {
    element = decodeURIComponent(element).replace(/#/g, "");
    var keyAndValue = element.split("=");
    json[keyAndValue[0]] = keyAndValue[1];
  });
  return json;
}

function getQueryStringValue(key) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  );
}

function getURLPath() {
  var url_path = location.pathname.slice(1);
  if (url_path.charAt(url_path.length === "/")) {
    url_path = url_path.slice(0, url_path.length - 1);
  }
  return url_path;
}

export const STORAGE = (function () {
  function localStorageTest() {
    try {
      localStorage.setItem("test", "test");
      localStorage.getItem("test");
      localStorage.removeItem("test");
      return true;
    } catch (e) {
      return false;
    }
  }
  return localStorageTest() ? useLocalStorage : useCookies;
})();

function useLocalStorage(key, value, remove) {
  if (value) {
    localStorage.setItem(key, value);
    return;
  }

  var temp = localStorage.getItem(key);
  if (remove) {
    localStorage.removeItem(key);
  }
  return temp;
}

export function useCookies(key, value, remove) {
  if (value) {
    var expiry = new Date(Number(new Date()) + 30 * 24 * 3600000).toString();
    document.cookie = key + "=" + value + ";path=/;expires=" + expiry + ";";
    return;
  }
  var all = document.cookie.split(";");
  var temp = null;
  for (var i in all) {
    var keyAndValue = all[i].split("=");
    if (keyAndValue[0].trim() == key.trim()) {
      temp = keyAndValue[1];
      break;
    }
  }
  if (remove) {
    document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  }
  return temp;
}

export const makeRequestAuth = (
  data,
  callback,
  extra_headers,
  url,
  signal = false
) => {
  // if(useCookies('s_e_t') == 0 && window.location.pathname.includes("/admin/")){
  //     showError('<h3>You are Loged out, Please login again</h3>');
  //     // return;
  // }
  if (!extra_headers) extra_headers = {};

  if (!url) {
    url = auth_url + "/api/graph";
  }

  if (!data) {
    data = {};
  }
  // else
  //     data.query = eval("graphql."+data.query)

  if (url.indexOf(auth_url) == -1) {
    url = auth_url + url; //`${auth_url}${url}`
  }

  if (data.tag) {
    url = url + "/" + data.tag; //`${url}/${data.tag}`
  }

  if (!callback) {
    callback = function (response) {
      applog(event, response);
    };
  }

  let headers = {
    "Content-Type": "application/json",
    pltfm: 4,
    lng: getCookie("lng") ? getCookie("lng") : "en",
  };

  if (!extra_headers) extra_headers = {};

  for (var i = 0; i < Object.keys(extra_headers).length; i++) {
    var key = Object.keys(extra_headers)[i];
    headers[key] = extra_headers[key];
  }

  if (data.query) {
    //for mod security
    data.query = data.query.replace(new RegExp("\n", "g"), "");
  }
  const endPoints = data?.query?.split(".");
  const subEndPoint = endPoints && endPoints[2] ? endPoints[2] : "";
  url = `${url}/${subEndPoint}`;

  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: headers,
    credentials: "include",
  };
  if (signal) {
    params["signal"] = signal;
  }
  fetch(url, params)
    .then(function (res) {
      return res.json();
    })
    .catch(function (error) {
      callback({ error: 1, error_msg: error });
    })
    .then(function (response) {
      callback(response);
    });
};

export const uploadRequest = (data, callback, url) => {
  if (!url) url = auth_url + "/api/graph";

  if (!callback) {
    callback = function (response) {
      applog(event, response);
    };
  }

  if (url.indexOf(auth_url) == -1) url = auth_url + url; //`${auth_url}${url}`
  try {
    var request_data = JSON.parse(data.get("request_data"));

    if (request_data && request_data.query) {
      //for mod security
      request_data.query = request_data.query.replace(
        new RegExp("\n", "g"),
        ""
      );
    }
    var tag = request_data?.tag;
    if (tag) url = url + "/" + tag; //`${url}/${tag}`
    const endPoints = request_data?.query?.split(".");
    const subEndPoint = endPoints && endPoints[2] ? endPoints[2] : "";
    url = `${url}/${subEndPoint}`;

    data.set("request_data", JSON.stringify(request_data));
  } catch (e) {
    console.log("Exception", e);
    // applog('Exception',e)
  }

  fetch(url, {
    method: "POST",
    body: data,
    credentials: "include",
    headers: {
      pltfm: 4,
      lng: getCookie("lng") ? getCookie("lng") : "en",
    },
  })
    .then(function (res) {
      return res.json();
    })
    .catch(function (error) {
      callback({ error: 1, error_msg: error });
    })
    .then(function (response) {
      callback(response);
    });
};
export const uploadXHRRequest = (data, callback, url) => {
  if (!url) url = auth_url + "/api/graph";

  if (!callback) {
    callback = function (response) {
      applog(event, response);
    };
  }

  if (url.indexOf(auth_url) == -1) url = auth_url + url; //`${config.auth_url}${url}`
  try {
    var request_data = JSON.parse(data.get("request_data"));

    if (request_data && request_data.query) {
      //for mod security
      request_data.query = request_data.query.replace(
        new RegExp("\n", "g"),
        ""
      );
    }

    var tag = request_data.tag;
    if (tag) url = url + "/" + tag; //`${url}/${tag}`

    data.set("request_data", JSON.stringify(request_data));
  } catch (e) {
    applog("Exception", e);
  }

  let xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.setRequestHeader("pltfm", 4);
  xhr.setRequestHeader("lng", getCookie("lng"));
  xhr.withCredentials = true;
  xhr.send(data);
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == 200) {
      callback(JSON.parse(xhr.response));
    }
  };

  return xhr;
};

export const makeRequest = (
  requestType,
  callBack,
  params,
  headers,
  critical
) => {
  if (!params) {
    params = {};
  }
  if (!headers) {
    headers = {};
  }
  if (!critical) {
    critical = 0;
  }

  $.ajax({
    url: `${config.storeFrontApi}?_= ${new Date().getTime()}`,
    method: requestType,
    data: params,
    headers: headers,
    success: function (response) {
      try {
        response = JSON.parse(response);
        callBack(response);
        // if (!critical) {
        //  setIntoCache(path, params, response);
        // }
      } catch (e) {
        console.log(e);
        callBack({
          success: 0,
        });
      } finally {
      }
    },
    error: function (xhr, status, error) {
      if (process.env.NODE_ENV === "development") {
        var keys = Object.keys(xhr);
        for (var i in keys) {
          if (
            typeof xhr[keys[i]] !== "function" &&
            keys[i] !== "responseText"
          ) {
            console.error(keys[i] + " : " + xhr[keys[i]]);
          }
        }
        console.error(status + " : " + error.toString());
      }
    },
  });
};

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function removeSpecialCharacters(string) {
  return string.replace(/[&\/\\#,+()$~%.'’":*?<>{}]/g, "");
}

export const removeSplCharacters = (string) => {
  return string.replace(/[^\w\s]/gi, "");
};

export const validateEmail = (string) => {
  const str = string.trim();
  var reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(str);
};

export const validateWebhookUrl = (String) => {
  const str = String.trim();
  var reg =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
  return reg.test(str);
};
export const validateWebhookXApiKey = (String) => {
  const str = String.trim();
  var reg = /^([A-Za-z0-9_-]{13,60})$/;
  return reg.test(str);
};

export const validateCodeEmail = (string) => {
  const str = string.trim();
  var reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(str);
};

export const validatePointsEmail = (string) => {
  const str = string.trim();
  var reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(str);
};

export const validateLinksEmail = (string) => {
  const str = string.trim();
  var reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(str);
};

function getCookie(name) {
  var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
}

export const getCookieToken = (n) => {
  let a = `; ${document.cookie};domain= ${cookiesDomain};`.match(
    `;\\s*${n}=([^;]+)`
  );
  return a ? a[1] : "";
};

export const setGlobalCookie = (
  name,
  value,
  domain = window.location.hostname,
  minutes = -1
) => {
  var expires = "";
  if (minutes != -1) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    expires = date.toUTCString();
  } else {
    //assuming the cookie should be everlasting here
    expires = "Fri, 31 Dec 9999 23:59:59 GMT";
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    "; expires=" +
    expires +
    "; domain=" +
    domain +
    "; path=/";
};

// export const setCookie = (name,value,minutes)=> {
//     var expires = ""
//     if (minutes) {
//     var date = new Date()
//     date.setTime(date.getTime() + (minutes*60*1000))
//     expires = "; expires=" + date.toUTCString();
//     }else {//assuming the cookie should be everlasting heres
//     expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT"

//     }
//     document.cookie = name + "=" + (value || "") + expires + "; path=/; domain="+(config.storeFrontURL ? config.storeFrontURL : "")+";"
// }

export const setPlatfmCookie = (
  name,
  value,
  minutes,
  domain = window.location.hostname
) => {
  var expires = "";
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  } else {
    //assuming the cookie should be everlasting here
    expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
  }
  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; domain=" + domain + ";";
};

export const validatePassword = (pwd) => {
  var reg = new RegExp("^(?!.* )(?=.*[0-9])(?=.{8,})");
  return reg.test(pwd);
};

export const capitalize = (value) => {
  if (!value) {
    return value;
  }
  return (
    value && value.charAt(0) && value.charAt(0).toUpperCase() + value.slice(1)
  );
};

export const capitalizeEachWord = (string) => {
  if (!string) {
    return string;
  }
  const words =
    string &&
    string.split(" ").map((item) => {
      return capitalize(item);
    });
  return words && words.join(" ");
};

export const maskEmail = function (email) {
  return email.replace(/(.{2})(.*)(?=@)/, function (gp1, gp2, gp3) {
    for (let i = 0; i < gp3.length; i++) {
      gp2 += "*";
    }
    return gp2;
  });
};

export const getTaxType = (countryId, taxList, countryList) => {
  const countryCode = countryList.find(
    (country) => countryId === country.country_id
  ).iso;
  const countryTaxDetails = taxList.find((tax) => tax.country === countryCode);
  const taxType =
    countryTaxDetails &&
    countryTaxDetails.external_type.split("_")[1].toUpperCase();
  return taxType;
};

export const isBlockOpenLoop = (voucher_category, kyb_status) => {
  if (voucher_category === "open_loop") {
    if (kyb_status === 2) {
      return false;
    }
    return true;
  }
  return false;
};

export const validatePhoneNo = (number) => {
  const regex = /^\d{7,16}$/;
  const validatePhone = regex.test(number);
  return validatePhone;
};

export const showBaseCurrencyConversionTooltip = (
  baseCurrency,
  rewardCurrency,
  redemptionStatus = ""
) => {
  if (
    baseCurrency != rewardCurrency &&
    redemptionStatus.toLowerCase() === "redeemed"
  ) {
    return true;
  }
  return false;
};
